module.exports = __webpack_public_path__ + "img/infographic.16c426f4.svg";